export default import.meta.ROLLDOWN_FILE_URL_qS$ogeo1bKzhSn6Er403MQ